<template>
  <div class="datagrid-item">
    <div class="datagrid-title">Партнерить ссылки</div>
    <div class="datagrid-content mt-1"><b>{{ getVal() }}</b></div>
  </div>
</template>

<script>
import {defineComponent} from "vue"

export default defineComponent({
  name: "IsPartnerLinks",
  props: {
    data: {
      type: String,
      require: true,
    },
  },
  setup(props) {
    function getVal() {
      if (props.data["partner_links"] === 0) {
        return "Нет"
      } else if (props.data["partner_links"] === 1) {
        return "Да"
      } else {
        return "Не известно"
      }
    }

    return {
      getVal,
    }
  }
})
</script>

<style scoped>

</style>
